import DeviceDetector from "device-detector-js";
import { report } from '@/api/report';

export default {
	name: 'OS',

	data() {
		return {};
	},

	mounted() {
    try {
      const deviceDetector = new DeviceDetector();
      const deviceInfo = deviceDetector.parse(window.navigator.userAgent);
      
      report({
        event_type: 'view',
        event_value: `osforbiden_page&${deviceInfo.os.name}&${deviceInfo.os.version}`
      });
    }
    catch(err) {}
  },
};